<template>
  <div id="cdt-modal">
    <component :is="countdownTimerApp" v-if="countdownTimerApp" v-bind="countdownTimeAppProps" />
  </div>
</template>
<script lang="ts">
import { useEmitter } from '../../composition/useEmitter'
import { defineComponent, markRaw } from 'vue'
import { useScopedStore } from '../../../plugins/setupMicroAppStore'
import CountdownTimerEvents from '../../../events/CountdownTimer'
import { EventBus } from '@/models/event-bus'
import { resolveLocale } from '@/util/localeResolver'
import { defineAsyncMicroApp } from '@gohighlevel/ghl-module-federation-plugin'

export default defineComponent({
  data() {
    return {
      countdownTimerApp: null,
      countdownTimeAppProps: {},
    }
  },
  mounted() {
    const emitter = useEmitter()
    emitter.on(CountdownTimerEvents.EDIT_COUNTDOWN_TIMER, this.mountCDTModal)
  },
  beforeUnmount() {
    const emitter = useEmitter()
    emitter.off(CountdownTimerEvents.EDIT_COUNTDOWN_TIMER)
    this.unmountCDTModal()

  },
  methods: {
    async mountCDTModal(data: { timerId: string; source: string; locationId?: string }) {
      this.unmountCDTModal()
      try {
        const [Modal] = await defineAsyncMicroApp('countdownTimerApp', ['CountdownTimerModal'])
        const emitter = useEmitter()
        const user = (this as any).$store.getters['user/get']
        const store = (this as any).$store
        const finalLocale = resolveLocale(store)
        this.countdownTimeAppProps = {
          emitter,
          user,
          store: useScopedStore({
            state: ['locations', 'timeZone'],
          }),
          locale: finalLocale,
          location: data?.locationId || (this as any).$route.params.location_id,
          timerId: data?.timerId,
          source: data?.source,
        }
        emitter.on(CountdownTimerEvents.EDIT_COUNTDOWN_TIMER_CLOSE, this.handleModalClose)
        this.countdownTimerApp = markRaw(Modal)
      } catch (e) {
        console.error(e)
      }
    },
    handleModalClose(data: any) {
      const emitter = useEmitter()
      emitter.off(CountdownTimerEvents.EDIT_COUNTDOWN_TIMER_CLOSE, this.handleModalClose)
      EventBus.$emit(CountdownTimerEvents.EDIT_COUNTDOWN_TIMER_CLOSE, data)
      this.unmountCDTModal()
    },
    unmountCDTModal() {
      this.countdownTimerApp = null
      this.countdownTimeAppProps = {}
    },
  },
})
</script>
